import { useEffect } from "react";
import { useContext } from "react";

import { ExternalLinkModalContext } from "@/App/context";
import { useIsMedicareUser } from "@/App/hooks";

const isExternalUrl = (href: string): boolean => {
  try {
    const url = new URL(href, window.location.origin);
    return url.origin !== window.location.origin;
  } catch {
    return false;
  }
};

// @ts-ignore
export const ExternalLinkGuard = () => {
  const { open } = useContext(ExternalLinkModalContext);
  const { isMedicareUser } = useIsMedicareUser();

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (e.defaultPrevented) return;
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      let target = e.target as HTMLElement | null;
      while (target && !(target instanceof HTMLAnchorElement)) {
        target = target.parentElement;
      }
      if (!target) return;

      const href = target.getAttribute("href");
      if (!href) return;

      // ignore non-external links or if user is not medicare
      if (!isExternalUrl(href) || !isMedicareUser) return;

      e.preventDefault();

      open(href);
    };

    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [open]);

  return null;
};
